// extracted by mini-css-extract-plugin
export default {"carouselMedia":"Carousel_carouselMedia__ZsJET"};